"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InsaiDataClient = exports.InsaiClient = void 0;
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const ble_utils_1 = require("../lib/ble-utils");
const c = __importStar(require("../lib/constants"));
const nexus_utils_1 = require("../lib/nexus-utils");
const ble_utils_2 = require("../lib/ble-utils");
const operators_2 = require("rxjs/operators");
const socket_1 = require("../lib/socket");
const zip_samples_1 = require("../pipes/zip-samples");
const epoch_1 = require("../pipes/epoch");
const pipes_1 = require("@neurosity/pipes");
class InsaiClient extends socket_1.SocketClient {
    constructor(props) {
        super(props);
        this.connectionStatus = new rxjs_1.BehaviorSubject(false);
        this.deviceName = null;
        this.eventMarkers = null;
        //New data format for biostreams
        this.motionData = null;
        this.telemetryData = null;
        this.eegReading = null;
        this.gyroscopeReading = null;
        this.accelerometerReading = null;
        this.ppgReading = null;
        this.telemetryReading = null;
        this.ppgChannels = c.INSAI_PPG_CHANNELS;
        this.eegChannels = c.INSAI_EEG_CHANNELS;
        this.yDomainSettings = { eeg: [-1000, 1000], ppg: [-100, 100], accelerometer: [-1, 1], gyroscope: [-100, 100] };
        this.gatt = null;
        this.service = null;
        this.controlCharacteristic = null;
        this.stimulationCharacteristic = null;
        this.lastIndices = [-1, -1, -1, -1]; //EEG, PPG, Acc, Gyro
        this.lastTimestamps = [-1, -1, -1, -1]; //EEG, PPG, Acc, Gyro
        this.tryReconnect = false; // try to reconnect with device when connection is lost
        this.connectionStatus.subscribe((connected) => {
            var _a, _b;
            if (connected) {
                //TODO: Simplify and check if reading exists
                this.gain = props.gain;
                //EEG
                this.eegEpoch = zip_samples_1.zipSamples(this.eegReading, c.INSAI_EEG_CHANNELS, c.INSAI_EEG_SAMPLING_RATE)
                    .pipe(epoch_1.epochM({
                    duration: 250,
                    interval: 250,
                    channelNames: c.INSAI_EEG_CHANNELS,
                    samplingRate: c.INSAI_EEG_SAMPLING_RATE,
                    packetThreshold: 10,
                }))
                    .pipe(operators_1.multicast(() => new rxjs_1.Subject()));
                this.eegEpoch.connect();
                this.eegEpochFiltered = zip_samples_1.zipSamples(this.eegReading, c.INSAI_EEG_CHANNELS, c.INSAI_EEG_SAMPLING_RATE)
                    .pipe(epoch_1.epochM({
                    duration: 50,
                    interval: 50,
                    channelNames: c.INSAI_EEG_CHANNELS,
                    samplingRate: c.INSAI_EEG_SAMPLING_RATE,
                    packetThreshold: 10,
                }))
                    .pipe(pipes_1.notchFilter({
                    nbChannels: 8,
                    cutoffFrequency: 50,
                    filterHarmonics: true,
                    samplingRate: 250,
                }), pipes_1.highpassFilter({
                    cutoffFrequency: 0.5,
                    nbChannels: 8,
                    samplingRate: 250,
                }))
                    //.pipe(filterStreams({ nbChannels: c.INSAI_EEG_CHANNELS.length, samplingRate: c.INSAI_EEG_SAMPLING_RATE, cutoffFrequencies: [1, 100] }))
                    .pipe(operators_1.multicast(() => new rxjs_1.Subject()));
                this.eegEpochFiltered.connect();
                //EEG observable that can be used for different measurements (impedance, fft, simultaneous stimulation, etc.)
                this.eegFlexible = this.setEEGParameters(((_a = props.bufferProperties) === null || _a === void 0 ? void 0 : _a.duration) || 250, ((_b = props.bufferProperties) === null || _b === void 0 ? void 0 : _b.interval) || 250);
                this.eegFlexible.connect();
                //PPG
                this.ppgEpoch = zip_samples_1.zipSamples(this.ppgReading, c.INSAI_PPG_CHANNELS, c.INSAI_PPG_SAMPLING_RATE)
                    .pipe(epoch_1.epochM({
                    duration: 32,
                    interval: 32,
                    channelNames: c.INSAI_PPG_CHANNELS,
                    samplingRate: c.INSAI_PPG_SAMPLING_RATE,
                    packetThreshold: 5,
                }))
                    .pipe(operators_1.multicast(() => new rxjs_1.Subject()));
                this.ppgEpoch.connect();
                this.ppgEpochFiltered = zip_samples_1.zipSamples(this.ppgReading, c.INSAI_PPG_CHANNELS, c.INSAI_PPG_SAMPLING_RATE)
                    .pipe(epoch_1.epochM({
                    duration: 8,
                    interval: 8,
                    channelNames: c.INSAI_PPG_CHANNELS,
                    samplingRate: c.INSAI_PPG_SAMPLING_RATE,
                    packetThreshold: 5,
                }))
                    .pipe(epoch_1.filterStreams({ nbChannels: 1, samplingRate: c.INSAI_PPG_SAMPLING_RATE, cutoffFrequencies: [0.7, 3.5] }))
                    .pipe(operators_1.multicast(() => new rxjs_1.Subject()));
                this.ppgEpochFiltered.connect();
                //GYRO
                this.gyroEpoch = zip_samples_1.zipSamples(this.gyroscopeReading, c.INSAI_MOTION_CHANNELS, c.INSAI_MOTION_SAMPLING_RATE)
                    .pipe(epoch_1.epochM({
                    duration: 32,
                    interval: 32,
                    channelNames: c.INSAI_MOTION_CHANNELS,
                    samplingRate: c.INSAI_MOTION_SAMPLING_RATE,
                    packetThreshold: 5,
                }))
                    .pipe(operators_1.multicast(() => new rxjs_1.Subject()));
                this.gyroEpoch.connect();
                this.gyroEpochFiltered = zip_samples_1.zipSamples(this.gyroscopeReading, c.INSAI_MOTION_CHANNELS, c.INSAI_MOTION_SAMPLING_RATE)
                    .pipe(epoch_1.epochM({
                    duration: 8,
                    interval: 8,
                    channelNames: c.INSAI_MOTION_CHANNELS,
                    samplingRate: c.INSAI_MOTION_SAMPLING_RATE,
                    packetThreshold: 5,
                }))
                    .pipe(operators_1.multicast(() => new rxjs_1.Subject()));
                this.gyroEpochFiltered.connect();
                //ACCEL
                this.accelEpoch = zip_samples_1.zipSamples(this.accelerometerReading, c.INSAI_MOTION_CHANNELS, c.INSAI_MOTION_SAMPLING_RATE)
                    .pipe(epoch_1.epochM({
                    duration: 32,
                    interval: 32,
                    channelNames: c.INSAI_MOTION_CHANNELS,
                    samplingRate: c.INSAI_MOTION_SAMPLING_RATE,
                    packetThreshold: 5,
                }))
                    .pipe(operators_1.multicast(() => new rxjs_1.Subject()));
                this.accelEpoch.connect();
                this.accelEpochFiltered = zip_samples_1.zipSamples(this.accelerometerReading, c.INSAI_MOTION_CHANNELS, c.INSAI_MOTION_SAMPLING_RATE)
                    .pipe(epoch_1.epochM({
                    duration: 8,
                    interval: 8,
                    channelNames: c.INSAI_MOTION_CHANNELS,
                    samplingRate: c.INSAI_MOTION_SAMPLING_RATE,
                    packetThreshold: 5,
                }))
                    .pipe(operators_1.multicast(() => new rxjs_1.Subject()));
                this.accelEpochFiltered.connect();
            }
        });
    }
    setEEGParameters(duration, interval) {
        return zip_samples_1.zipSamples(this.eegReading, c.INSAI_EEG_CHANNELS, c.INSAI_EEG_SAMPLING_RATE)
            .pipe(epoch_1.epochM({
            duration: duration || 250,
            interval: interval || 250,
            channelNames: c.INSAI_EEG_CHANNELS,
            samplingRate: c.INSAI_EEG_SAMPLING_RATE,
            packetThreshold: 10,
        }))
            .pipe(operators_1.multicast(() => new rxjs_1.Subject()));
    }
    //TODO: Investigate control response
    async handleControl() {
        var _a;
        this.controlCharacteristic = await ((_a = this.service) === null || _a === void 0 ? void 0 : _a.getCharacteristic(c.INSAI_CONTROL_CHARACTERISTIC));
    }
    //TODO: Send stimulation commands
    async handleStimulation() {
        var _a;
        this.stimulationCharacteristic = await ((_a = this.service) === null || _a === void 0 ? void 0 : _a.getCharacteristic(c.INSAI_STIMULATION_CHARACTERISTIC));
    }
    async handleEEG() {
        var _a;
        const eegCharacteristic = await ((_a = this.service) === null || _a === void 0 ? void 0 : _a.getCharacteristic(c.INSAI_TX_CHARACTERISTIC));
        this.eegReading = (await ble_utils_1.observableCharacteristic(eegCharacteristic))
            .pipe(operators_1.map((d) => {
            const buffer = new Uint8Array(d.buffer);
            //const int8buffer = new Int8Array(d.buffer)
            //const untouchedBuffer = d.buffer
            const samples = nexus_utils_1.decodeEEGSamples(buffer.slice(0, buffer.length - 4), this.gain);
            const eventIndex = ble_utils_2.decodeUint24BitData(buffer.slice(buffer.length - 4, buffer.length - 1))[0];
            return {
                eventIndex: eventIndex,
                data: samples,
                timestamp: this.getTimestampStreams(eventIndex, 250, 1, 0),
            };
        }))
            .pipe(operators_2.mergeMap((r) => r.data.map((_, i) => {
            return {
                index: r.eventIndex,
                channel: i,
                timestamp: r.timestamp,
                samples: r.data[i],
            };
        })))
            .pipe(operators_1.multicast(() => new rxjs_1.Subject()));
        this.eegReading.connect();
    }
    async handleMotion() {
        var _a;
        const motionCharacteristic = await ((_a = this.service) === null || _a === void 0 ? void 0 : _a.getCharacteristic(c.INSAI_MOTION_CHARACTERISTIC));
        // const nChannels = c.MUSE_PPG_CHARACTERISTICS.length
        this.motionData = (await ble_utils_1.observableCharacteristic(motionCharacteristic))
            .pipe(operators_1.map((d) => {
            const buffer = new Uint8Array(d.buffer);
            const motionSamples = ble_utils_2.decodeUint16BitData(buffer.slice(0, 70));
            const eventIndex = ble_utils_2.decodeUint24BitData(buffer.slice(70, 73))[0];
            const telemetry = ble_utils_2.decodeUint16BitData(buffer.slice(75, 77))[0];
            const stimulationCounter = ble_utils_2.decodeUint16BitData(buffer.slice(77, 79))[0];
            const gyroSamples = nexus_utils_1.decodeGyro(motionSamples);
            const accelSamples = nexus_utils_1.decodeAccel(motionSamples);
            const ppgSamples = nexus_utils_1.decodePPG(motionSamples);
            return {
                eventIndex: eventIndex,
                timestamp: this.getTimestampStreams(eventIndex, 32, 1, 1),
                telemetry: telemetry,
                stimulationCounter: stimulationCounter,
                gyro: gyroSamples,
                accel: accelSamples,
                ppg: ppgSamples,
            };
        }))
            .pipe(operators_1.multicast(() => new rxjs_1.Subject()));
        this.motionData.connect();
    }
    async handleTelemetry() {
        var _a;
        this.telemetryData = (_a = this.motionData) === null || _a === void 0 ? void 0 : _a.pipe(operators_1.map((motion) => {
            return {
                //TODO Update
                sequenceId: motion.eventIndex,
                batteryLevel: motion.telemetry,
                fuelGaugeVoltage: 0,
                temperature: 0,
            };
        })).pipe(operators_1.multicast(() => new rxjs_1.Subject()));
        this.telemetryData.connect();
    }
    async handleGyroscope() {
        var _a;
        this.gyroscopeReading = (_a = this.motionData) === null || _a === void 0 ? void 0 : _a.pipe(operators_1.map((motion) => {
            return {
                eventIndex: motion.eventIndex,
                data: motion.gyro,
                timestamp: motion.timestamp,
            };
        })).pipe(operators_2.mergeMap((r) => r.data.map((_, i) => {
            return { index: r.eventIndex, channel: i, timestamp: r.timestamp, samples: r.data[i] };
        }))).pipe(operators_1.multicast(() => new rxjs_1.Subject()));
        this.gyroscopeReading.connect();
    }
    async handleAccelerometer() {
        var _a;
        this.accelerometerReading = (_a = this.motionData) === null || _a === void 0 ? void 0 : _a.pipe(operators_1.map((motion) => {
            return {
                eventIndex: motion.eventIndex,
                data: motion.accel,
                timestamp: motion.timestamp,
            };
        })).pipe(operators_2.mergeMap((r) => r.data.map((_, i) => {
            return { index: r.eventIndex, channel: i, timestamp: r.timestamp, samples: r.data[i] };
        }))).pipe(operators_1.multicast(() => new rxjs_1.Subject()));
        this.accelerometerReading.connect();
    }
    async handlePPG() {
        var _a;
        this.ppgReading = (_a = this.motionData) === null || _a === void 0 ? void 0 : _a.pipe(operators_1.map((motion) => {
            return {
                eventIndex: motion.eventIndex,
                data: motion.ppg,
                timestamp: motion.timestamp,
            };
        })).pipe(operators_2.mergeMap((r) => r.data.map((_, i) => {
            return { index: r.eventIndex, channel: i, timestamp: r.timestamp, samples: r.data[i] };
        }))).pipe(operators_1.multicast(() => new rxjs_1.Subject()));
        this.ppgReading.connect();
    }
    getTimestampStreams(eventIndex, samplingRate, nSamples, stream) {
        const delta = 1000 * (1.0 / samplingRate) * nSamples;
        if (this.lastIndices[stream] === -1 || this.lastTimestamps[stream] === -1) {
            this.lastIndices[stream] = eventIndex;
            this.lastTimestamps[stream] = new Date().getTime() - delta;
        }
        /*
        // handle wrap around
        while (this.lastIndices[stream] - eventIndex > 0x1000) {
          eventIndex += 0x10000
        }
        */
        if (eventIndex === this.lastIndices[stream]) {
            return this.lastTimestamps[stream];
        }
        if (eventIndex > this.lastIndices[stream]) {
            this.lastTimestamps[stream] += delta * (eventIndex - this.lastIndices[stream]);
            this.lastIndices[stream] = eventIndex;
            return this.lastTimestamps[stream];
        }
        else {
            return this.lastTimestamps[stream] - delta * (this.lastIndices[stream] - eventIndex);
        }
    }
    async sendCommandControl(cmd) {
        var _a;
        await ((_a = this.controlCharacteristic) === null || _a === void 0 ? void 0 : _a.writeValue(cmd));
        //this.controlCharacteristic?.startNotifications
    }
    async sendCommandStimulation(cmd) {
        var _a;
        await ((_a = this.stimulationCharacteristic) === null || _a === void 0 ? void 0 : _a.writeValue(cmd));
        //this.controlCharacteristic?.startNotifications
    }
    async initialize(config) {
        const { device } = config || {};
        if (device) {
            this.gatt = await device.gatt.connect();
        }
        this.deviceName = this.gatt.device.name || null;
        this.service = await this.gatt.getPrimaryService(c.INSAI_SERVICE);
        // initialize data streams
        await this.handleControl();
        await this.handleStimulation();
        await this.handleEEG();
        await this.handleMotion();
        await this.handleTelemetry();
        await this.handleGyroscope();
        await this.handlePPG();
        await this.handleAccelerometer();
        // TODO: move init to constructor, so it can be used w/o connecting headband
        this.eventMarkers = new rxjs_1.Subject();
        this.connectionStatus.next(true);
        this.lastIndices = [-1, -1, -1, -1]; //EEG, Motion,
        this.lastTimestamps = [-1, -1, -1, -1]; //EEG, Motion
    }
    async start(samplingRate = 255, bias = 1, gains = [32, 32, 32, 32, 32, 32, 32, 32], impedance = 0) {
        /*
        if (samplingRate != 255 && samplingRate != 150 && samplingRate != 149) {
          console.log('samplingRate value selected is not accepted. Either set it to 250sps (0x96) or 500sps (0x95)')
          return null
        }
        if (bias != 1 && bias != 0) {
          console.log('Bias value selected is not accepted. Either set it to BIAS ON (0x01) or BIAS OFF (0x00)')
          return null
        }*/
        /*
        if (gain != 0 && gain != 16 && gain != 32 && gain != 48 && gain != 64 && gain != 80 && gain != 96) {
          console.log(
            'Gain value selected is not accepted. Either set it to GAIN 1 (0x00), GAIN 2 (0x10), GAIN 4 (0x20), GAIN 6 (0x30), GAIN 8 (0x40), GAIN 12 (0x50), GAIN 24 (0x60)',
          )
          return null
        }*/
        //console.log(gs)
        const cmd2 = [[1, samplingRate, bias], gains, impedance].flat();
        const commandSent = new Uint8Array(cmd2);
        //console.log(cmd2)
        console.log('Command sent:', commandSent);
        await this.sendCommandControl(commandSent); // This starts EEG/PPG streaming
    }
    async startStimulation(voltage, duration) {
        await this.sendCommandStimulation(new Uint8Array([2, voltage, duration])); // This starts stimulation
    }
    async stopStimulation() {
        await this.sendCommandStimulation(new Uint8Array([0])); // This stops stimulation
    }
    async stop() {
        await this.sendCommandStimulation(new Uint8Array([0])); // This stops stimulation
        await this.sendCommandControl(new Uint8Array([0, 255, 10, 10, 10, 10, 10, 10, 10, 10])); // This stops EEG/PPG streaming
    }
    /*async resume() {
      await this.sendCommand('d')
    }
    //TODO: Need to test reset function
    async reset_device() {
      await this.sendCommand('*1')
    }*/
    async injectMarker(value, timestamp = new Date().getTime()) {
        var _a;
        await ((_a = this.eventMarkers) === null || _a === void 0 ? void 0 : _a.next({ value, timestamp }));
    }
}
exports.InsaiClient = InsaiClient;
class InsaiDataClient extends InsaiClient {
    constructor(props) {
        super(props);
    }
    // TODO: Ensure all datastreams are sent in the same manner on both Muse and Insai -> probably use Epoch data structure
    openStream(id) {
        var _a, _b, _c, _d, _e, _f;
        this.id = id;
        this.epochSub = (_a = this.eegEpoch) === null || _a === void 0 ? void 0 : _a.subscribe((e) => this.sendEpoch(id, e));
        this.ppgSub = (_b = this.ppgEpoch) === null || _b === void 0 ? void 0 : _b.subscribe((p) => this.sendPPG(id, p));
        this.accelSub = (_c = this.accelEpoch) === null || _c === void 0 ? void 0 : _c.subscribe((a) => this.sendAccel(id, a));
        this.gyroSub = (_d = this.gyroEpoch) === null || _d === void 0 ? void 0 : _d.subscribe((g) => this.sendGyro(id, g));
        this.teleSub = (_e = this.telemetryData) === null || _e === void 0 ? void 0 : _e.subscribe((t) => this.sendTele(id, t));
        this.eventSub = (_f = this.eventMarkers) === null || _f === void 0 ? void 0 : _f.subscribe((e) => this.sendEvent(id, e));
    }
    closeStream() {
        var _a, _b, _c, _d, _e, _f;
        (_a = this.epochSub) === null || _a === void 0 ? void 0 : _a.unsubscribe();
        (_b = this.ppgSub) === null || _b === void 0 ? void 0 : _b.unsubscribe();
        (_c = this.accelSub) === null || _c === void 0 ? void 0 : _c.unsubscribe();
        (_d = this.gyroSub) === null || _d === void 0 ? void 0 : _d.unsubscribe();
        (_e = this.teleSub) === null || _e === void 0 ? void 0 : _e.unsubscribe();
        (_f = this.eventSub) === null || _f === void 0 ? void 0 : _f.unsubscribe();
    }
}
exports.InsaiDataClient = InsaiDataClient;
//# sourceMappingURL=insai.js.map